package com.zq.webproject.model

import kotlinx.serialization.Serializable

/**
 * 排行榜用户信息（根据实际接口响应调整）
 */
@Serializable
data class RankingUser(
    val username: String? = null,      // 用户名
    val totalIncome: Double? = null    // 总收益
)

/**
 * 排行榜响应模型
 * 实际响应示例：{"code":200,"message":"获取成功","data":[{"username":"张三","totalIncome":1111.00}]}
 */
@Serializable
data class RankingResponse(
    val code: Int? = null,              // 状态码
    val message: String? = null,        // 消息
    val data: List<RankingUser>? = null  // 排行榜列表
)